import React from 'react'

import FieldGroupComponent from '../../components/core/FieldGroupComponent/FieldGroupComponent'

class SignUpFormFieldsLayout extends React.Component {
    render() {
        return <div>
            <FieldGroupComponent
                label="First Name"
                name="firstName"
                type="text"
                formProps={{
                    maxLength: 30,
                }}
            />
            <FieldGroupComponent
                label="Last Name"
                name="lastName"
                type="text"
                formProps={{
                    maxLength: 30,
                }}
            />
            <FieldGroupComponent
                label="Email"
                name="email"
                type="text"
                formProps={{
                    maxLength: 100,
                }}
            />
            <FieldGroupComponent
                label="Password"
                name="password"
                type="password"
                formProps={{
                    maxLength: 16,
                }}
            />
            <FieldGroupComponent
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                formProps={{
                    maxLength: 16,
                }}
            />
        </div>
    }
}

export default SignUpFormFieldsLayout



// WEBPACK FOOTER //
// ./src/layouts/SignUp/SignUpFormFieldsLayout.js